import { render, staticRenderFns } from "./TextOverSizeImg.vue?vue&type=template&id=41796edf&scoped=true&"
var script = {}
import style0 from "./TextOverSizeImg.vue?vue&type=style&index=0&id=41796edf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41796edf",
  null
  
)

export default component.exports